import SVG from "../Assests/SVG";
import { Info } from "@mui/icons-material";
import { RouteType } from "./Routesconfig";
import InsightsOverview from "../Screens/Insights/InsightsOverview";
import Screen from "./Layout/Screen";
import { AppRoutes } from "./Layout/Routes";

const InfraStructureAppRoutes: RouteType[] = [
  {
    path: AppRoutes.INFRADASHBOARD,
    state: "InfraDashboard",
    element: <Screen.InfrastructureDasboard />,
    sidebarProps: {
      displayText: "global.Dashboard",
      icon: <SVG.Dashboard />,
    },
    role: "SUPER_ADMIN",
    routeName: "INFRASTRUCTURE",
    child: [
      {
        path: AppRoutes.INFRADASHBOARDCORROSIONDETECTION,
        element: <Screen.CorrosionDetection />,
        state: "InfraCorrosion",
        sidebarProps: {
          displayText: "global.CorrosionDetection",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "INFRASTRUCTURE",
      },

      {
        path: AppRoutes.INFRADASHBOARDLEAKDETECTION,
        element: <Screen.LeakDetection />,
        state: "InfraLeak",
        sidebarProps: {
          displayText: "global.LeakDetection",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "INFRASTRUCTURE",
      },
      {
        path: AppRoutes.INFRADASHBOARDCRACKDETECTION,
        element: <Screen.CrackDetection />,
        state: "InfraCrack",
        sidebarProps: {
          displayText: "global.CrackDetection",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "INFRASTRUCTURE",
      },
      {
        path: AppRoutes.INFRADASHBOARDOPENCLOSEDETECTION,
        element: <Screen.OpenCloseDetection />,
        state: "InfraOpenOrCheck",
        sidebarProps: {
          displayText: "global.DetectionType",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "INFRASTRUCTURE",
      },
    ],
  },
  {
    path: AppRoutes.INFRAREPORT,
    state: "InfraReportSummary",
    element: <Screen.InfrastructureDasboard />,
    sidebarProps: {
      displayText: "global.ReportSummary",
      icon: <SVG.ReportSummary />,
    },
    role: "SUPER_ADMIN",
    routeName: "INFRASTRUCTURE",
    child: [
      {
        path: AppRoutes.INFRAREPORTCORROSIONDETECTION,
        element: <Screen.InfraReportSummary />,
        state: "InfraCorrosion",
        sidebarProps: {
          displayText: "global.CorrosionDetection",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "INFRASTRUCTURE",
      },

      {
        path: AppRoutes.INFRAREPORTLEAKDETECTION,
        element: <Screen.InfraReportSummary />,
        state: "InfraLeak",
        sidebarProps: {
          displayText: "global.LeakDetection",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "INFRASTRUCTURE",
      },

      {
        path: AppRoutes.INFRAREPORTCRACKDETECTION,
        element: <Screen.InfraReportSummary />,
        state: "InfraOpenOrClose",
        sidebarProps: {
          displayText: "global.CrackDetection",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "INFRASTRUCTURE",
      },
    ],
  },
  {
    path: AppRoutes.INFRAMAINTENANCE,
    state: "InfraMaintenance",
    element: <Screen.AgriDashboardLayout />,
    sidebarProps: {
      displayText: "global.PredictiveMaintenance",
      icon: <SVG.PredictiveMaintenance />,
    },
    role: "SUPER_ADMIN",
    routeName: "INFRASTRUCTURE",
    child: [
      {
        path: AppRoutes.INFRAMAINTENANCEASSETOVERVIEW,
        element: <Screen.AgriDashboardLayout />,
        state: "InfraAsset",
        sidebarProps: {
          displayText: "global.AssetOverview",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "INFRASTRUCTURE",
      },

      {
        path: AppRoutes.INFRAMAINTENANCESERVICESCHEDULETIMELINE,
        element: <Screen.AgriDashboardLayout />,
        state: "InfraServiceScheduleTimeline",
        sidebarProps: {
          displayText: "global.ServiceScheduleTimeline",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "INFRASTRUCTURE",
      },
    ],
  },
  {
    path: AppRoutes.INFRASUBSCRIBEFEATURES,
    state: "InfraSubscribe",
    element: <Screen.AgriDashboardLayout />,
    sidebarProps: {
      displayText: "global.SubscribeFeatures",
      icon: <SVG.Subscribe />,
    },
    role: "SUPER_ADMIN",
    routeName: "INFRASTRUCTURE",
    child: [
      {
        path: AppRoutes.INFRASUBSCRIBEFEATUREADDDEVICE,
        element: <Screen.AgriDashboardLayout />,
        state: "InfraAddDevice",
        sidebarProps: {
          displayText: "global.AddMultipleDevice",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "INFRASTRUCTURE",
      },

      {
        path: AppRoutes.INFRASUBSCRIBEIMPACTANALYSIS,
        element: <Screen.AgriDashboardLayout />,
        state: "InfraImpactAnalysis",
        sidebarProps: {
          displayText: "global.ImpactAnalysis",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "INFRASTRUCTURE",
      },
    ],
  },
  {
    path: AppRoutes.DASHBOARDINSIGHTS,
    state: "InfraDashboard",
    element: <Screen.InsightsOverview />,
    role: "SUPER_ADMIN",
    routeName: "INFRASTRUCTURE",
  },
];

export default InfraStructureAppRoutes;
